// useFakeProgress.ts
export function useFakeProgress() {
  const progress = ref(0);
  const enableTransition = ref(true); // 控制是否启用过渡动画
  let intervalId: number | null = null;

  /**
   * 启动进度条
   * @param pollInterval - 服务端等待的最短轮询时间（秒），用来调整进度条的速度
   * @param maxProgress - 最大进度百分比（用于初期加载阶段），默认为 70%
   */
  const startFakeProgress = (maxProgress: number = 70, pollInterval: number = 50) => {
    // 清除之前的定时器
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }

    // 禁用过渡动画,避免从上一个进度值回退到 0 的动画
    enableTransition.value = false;
    progress.value = 0;  // 立即重置为 0

    // 在下一帧重新启用过渡动画并开始进度增长
    requestAnimationFrame(() => {
      enableTransition.value = true;

      const updateInterval = 100; // 每 100 毫秒更新一次
      if(pollInterval < 50)
        pollInterval = 50
      const totalSteps = (pollInterval * 1000) / updateInterval; // 总的更新次数
      const increment = maxProgress / totalSteps; // 每次更新的步幅

      intervalId = window.setInterval(() => {
        if (progress.value < maxProgress) {
          // 进度缓慢且平滑地增加到 maxProgress
          progress.value += increment * (0.8 + Math.random() * 0.4); // 添加随机性使增长更自然
          if (progress.value > maxProgress) {
            progress.value = maxProgress; // 限制最大进度为 maxProgress
          }
        } else {
          clearInterval(intervalId as number);
        }
      }, updateInterval); // 每 100 毫秒更新进度
    });
  };

  /**
   * 完成进度条到 100%
   */
  const finishProgress = (): Promise<void> => {
    return new Promise((resolve) => {
      if (intervalId) clearInterval(intervalId);

      const targetProgress = 100;
      const remainingProgress = targetProgress - progress.value;
      const remainingSteps = 30; // 将剩余的加载分成 30 步
      const stepIncrement = remainingProgress / remainingSteps;

      const finishInterval = window.setInterval(() => {
        if (progress.value < targetProgress) {
          progress.value += stepIncrement;
          if (progress.value >= targetProgress) {
            progress.value = targetProgress; // 确保最终到达 100%
            clearInterval(finishInterval);
            resolve();
          }
        }
      }, 50); // 每 50 毫秒更新一次，以更快到达 100%
    });
  };

  /**
   * 重置进度条
   */
  const resetProgress = () => {
    progress.value = 0;
  };

  return {
    progress,
    enableTransition,
    startFakeProgress,
    finishProgress,
    resetProgress
  };
}